@if (allBadges | filter : badgesForRoleFilter(); as allBadges) {
  @if (!allBadges.length) {
    <p>{{ "memberBadges.empty" | translate }}</p>
  }
  @for (badge of allBadges; track badge) {
    <div class="badge">
      <mat-slide-toggle
        [checked]="_selectedBadgeIds | arrayIncludes : badge.id"
        (change)="badgeToggle.emit({badge, checked: $event.checked})"
        >
      </mat-slide-toggle>
      @if (!!badge.fileId) {
        <ca-image-loader
          class="m-4 badgeListImage"
          fit="contain"
          [image]="{ id: badge?.fileId } | filedownloadurl | async"
          [showPlaceholder]="false"
        ></ca-image-loader>
      }
      <div class="flex flex-col items-start">
        <label class="font-semibold block">
          {{ badge.name }}
        </label>
        <p>
          {{ badge.description }}
        </p>
      </div>
    </div>
  }
}
